import React from 'react'
import {
  FormDashboardLabel as Label, FormRow,
} from '../../../components'
import Select from 'react-select'
import { Plus } from 'react-feather'
import { Link } from 'react-router-dom'
import { PartnerTable } from './partner-table'
import { useViewport, viewportBreakpoint } from '../../../utils'

const ContentOfficialPartners = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <form>
      <div className="flex justify-between items-center mb-5 lg:mb-8">
        <p className="text-lg font-bold">Partners</p>
        <Link
          className="text-sm text-primary flex items-center cursor-pointer"
          to="/dashboard/profile/partners/edit"
        >
          <Plus className="mr-1" style={{width: '14px'}}/>
          <p>Add <span className="hidden lg:inline">New Partner</span></p>
        </Link>
      </div>
      {
        isMobile &&
        <FormRow>
          <Label>Add New Partner</Label>
          <Select options={[]} placeholder="Choose Partners" className="text-sm"/>
        </FormRow>
      }
      <FormRow last>
        <div className="lg:hidden">
          <Label>Partners</Label>
        </div>
        <div className="mobile-fullwidth">
          <PartnerTable />
        </div>
      </FormRow>
    </form>
  )
}

export { ContentOfficialPartners }